export default function (element) {
  element.disabled = false;
  element.classList.remove("disabled");

  // Broadcast state change so that custom components can re-initialize their wrappers
  element.dispatchEvent(new CustomEvent("element:enable", { bubbles: true }));
}
